import React, { Fragment, useState } from "react";
import { Backdrop, Modal } from "@mui/material";
import { FiX } from "react-icons/fi";
import styles from "./team_member_card.module.scss";
import { getAssets, htmlParse } from "@unisearch/helpers";

const TeamMemberCard = ({ data, ...props }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <div className={styles.team_member_card}>
        <div className={styles.member_image_wrapper} onClick={handleOpen}>
          <img
            src={
              data?.profileImageSrc ??
              getAssets("assets/student-avatar-big.png")
            }
            alt={data?.name}
          />
        </div>
        <div className={styles.member_info}>
          <h5 className={styles.member_name} onClick={handleOpen}>
            {`${data?.firstName} ${data?.middleName} ${data?.lastName}`}
          </h5>
          <div className={styles.member_designation}>
            {data?.designationName}
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="modal sm">
          <button
            className={`cross_icon ${styles.cross_icon}`}
            onClick={handleClose}
          >
            <FiX />
          </button>
          <div className="modal_body">
            <div className={styles.team_member_modal_wrapper}>
              <div className={styles.team_member_avatar_wrapper}>
                <div className={styles.member_avatar}>
                  <img
                    src={
                      data?.profileImageSrc ??
                      getAssets("assets/student-avatar-big.png")
                    }
                    alt={data?.name}
                  />
                </div>
                <h4 className={styles.member_name}>
                  {" "}
                  {`${data?.firstName} ${data?.middleName} ${data?.lastName}`}
                </h4>
                <div className={styles.member_designation}>
                  {data?.designationName}
                </div>
              </div>

              <div className={styles.team_member_bio_wrapper}>
                {/* <div className={styles.bio_title}>Bio Info</div> */}
                <div className={styles.bio_desc}>
                  {htmlParse(data?.biography)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default TeamMemberCard;
